module.exports = __webpack_public_path__ + "static/media/steel_shield.af13ca32.png";